var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Observable, observe, Scope } from 'wdc-cube';
import { formatDateAtTime } from '../../../../domain';
/**
 * Uma tentativa de entrar no painel recusada pelo bloqueio da empresa, ja escrita para
 * a tela.
 *
 * Mora no conceito Empresas porque duas telas a mostram: o dialogo de liberar acesso,
 * para o administrador geral, e Usuarios da empresa, para o administrador principal
 * depois da reativacao (decisao de 08/10/2026).
 */
let BlockedAttemptScope = class BlockedAttemptScope extends Scope {
    constructor() {
        super(...arguments);
        this.when = '';
        this.name = '';
        this.email = '';
    }
};
__decorate([
    observe(),
    __metadata("design:type", Object)
], BlockedAttemptScope.prototype, "when", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BlockedAttemptScope.prototype, "name", void 0);
__decorate([
    observe(),
    __metadata("design:type", Object)
], BlockedAttemptScope.prototype, "email", void 0);
BlockedAttemptScope = __decorate([
    Observable
], BlockedAttemptScope);
export { BlockedAttemptScope };
export function blockedAttemptScopes(attempts, update) {
    return attempts.map((attempt) => {
        const scope = new BlockedAttemptScope();
        scope.when = formatDateAtTime(attempt.attemptedAt);
        scope.name = attempt.name || '-';
        scope.email = attempt.email;
        scope.update = update;
        return scope;
    });
}
//# sourceMappingURL=blocked-attempt.scope.js.map